import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'eci-so-create-template-popup',
    templateUrl: './so-create-template-popup.component.html',
    styleUrls: ['./so-create-template-popup.component.scss']
})
export class SaleOrderCreateTemplatePopupComponent {

    @Input() listOfMarketplaces: any;

    selectedMarketplace: number;

    constructor(
        private dialog: MatDialogRef<SaleOrderCreateTemplatePopupComponent>,
    ) {
    }

    add(marketplaceId: number = this.selectedMarketplace): void {
        this.dialog.close(marketplaceId);
    }
}
